import React, { Component } from 'react';
import { customFetchV2 } from '../../../services/custom-fetch-v2.ts';
import Loading from '../Loading.jsx';
import SectionHeader from './SectionHeader.tsx';

class BillingSummarySection extends Component {
  state = {
    isLoading: true,
    cards: [],
  };

  componentDidMount() {
    this.loadOverview();
  }

  loadOverview = () => {
    this.setState({
      isLoading: true,
    });

    customFetchV2('/api/billing/overview', {
      method: 'GET',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Ooops');
        }

        const { data } = response;
        this.setState({
          isLoading: false,
          cards: data.cards,
        });
      })
      .catch((error) => {
        this.setState({
          errorMsg: error.message,
          isLoading: false,
        });
      });
  };

  renderCards = cards => cards.map((card, ix) => (
    <Card key={ix} title={card.title} value={card.value}/>
  ));

  renderContent() {
    if (this.state.isLoading) {
      return <Loading/>;
    }

    return (
      <div className="columns">
        {this.renderCards(this.state.cards)}
      </div>
    );
  }

  render() {
    return (
      <div className="section">
        <SectionHeader title="Billing Overview" />
        {this.renderContent()}
      </div>
    );
  }
}

function Card(props) {
  return (
    <div className="column">
      <div className="notification has-text-centered">
        <h1 className="title is-4">{props.value}</h1>
        <p className="subtitle is-6">{props.title}</p>
      </div>
    </div>
  );
}

export default BillingSummarySection;
